import dayjs from 'dayjs';

export function getNumberOfInstallments(totalBalance, paymentAmount) {
  return Math.ceil(totalBalance / paymentAmount);
}

export function getArrangementEndDate(
  startDate,
  totalBalance,
  paymentAmount,
  frequency
) {
  // One off payments have the same end date and start date.
  if (frequency == 'One') {
    return startDate;
  }
  const numberOfInstallments =
    getNumberOfInstallments(totalBalance, paymentAmount) - 1;
  return dayjs(startDate)
    .add(
      frequency == 'Fortnightly'
        ? numberOfInstallments * 2
        : numberOfInstallments,
      frequency == 'Months' ? 'month' : 'week'
    )
    .toDate();
}

export function getArrangementInstallments(
  startDate,
  totalBalance,
  paymentAmount,
  frequency
) {
  const installments = [];
  const numberOfInstallments = getNumberOfInstallments(
    totalBalance,
    paymentAmount
  );
  for (let i = 0; i < numberOfInstallments; i++) {
    const installmentNumber = i + 1;
    const remaingingBalance = totalBalance - paymentAmount * installmentNumber;
    installments.push({
      number: installmentNumber,
      date: dayjs(startDate)
        .add(
          frequency == 'Fortnightly' ? i * 2 : i,
          frequency == 'Months' ? 'month' : 'week'
        )
        .toDate(),
      // If the last payment would put the customer back in credit, the amount
      // should only be what is needed to cover the remaining balance.
      amount:
        remaingingBalance >= 0
          ? paymentAmount
          : paymentAmount + remaingingBalance,
      // Balance should always be zero or greater, as the final payment amount
      // is dynamic as per above.
      balance: remaingingBalance >= 0 ? remaingingBalance : 0,
    });
  }
  return installments;
}
